import './template-empty.css';

export const TemplateEmpty = {
	template: `
		<div class="booking-resource-creation-wizard-message-template-empty">
			<div class="booking-resource-creation-wizard-message-template-empty-icon"></div>
			<div class="booking-resource-creation-wizard-message-template-empty-text">
				{{ loc('BRCW_MESSAGE_TEMPLATE_SOON_TEXT') }}
			</div>
		</div>
	`,
};
